import Image1 from '../assets/images/faculty/1.jpg';
import Image2 from '../assets/images/faculty/2.jpg';
import Image3 from '../assets/images/faculty/3.jpg';
import Image4 from '../assets/images/faculty/4.jpg';
import Image5 from '../assets/images/faculty/5.jpg';
import Image6 from '../assets/images/faculty/6.jpg';

export const facultyData = [
  {
    id: 1,
    name: 'Piyush Soni Sir',
    designation: 'Founder Director & Mathematics Faculty',
    qualification: 'Mathematics Mentor',
    experience: '13 Years',
    specialization: 'IIT-JEE & Mathematics',
    achievements: [
      'Founder of Mantra Prayas',
      'Mentored multiple IIT & NIT selections',
      'Expert in competitive exam strategies'
    ],
    image: Image1
  },

  {
    id: 2,
    name: 'Surjeet Singh Rathore Sir',
    designation: 'HOD – Physics',
    qualification: 'Senior Physics Faculty',
    experience: '8 Years',
    specialization: 'Physics for IIT-JEE & NEET',
    achievements: [
      'Strong conceptual teaching',
      'Specialist in problem-solving',
      'Known for result-oriented teaching'
    ],
    image: Image2
  },

  {
    id: 3,
    name: 'Harendra Singh Sir',
    designation: 'HOD – Chemistry',
    qualification: 'Senior Chemistry Faculty',
    experience: '20 Years',
    specialization: 'Chemistry for IIT-JEE & NEET',
    achievements: [
      '20+ years of teaching experience',
      'Concept clarity expert',
      'Guided numerous competitive exam selections'
    ],
    image: Image3
  },

  {
    id: 4,
    name: 'Ravi Sharma Sir',
    designation: 'Mathematics Faculty',
    qualification: 'Senior Mathematics Teacher',
    experience: '10 Years',
    specialization: 'JEE Mathematics',
    achievements: [
      'Expert in algebra & calculus',
      'Student-friendly teaching approach',
      'Consistent academic results'
    ],
    image: Image4
  },

  {
    id: 5,
    name: 'Devendra Sen Sir',
    designation: 'Physics Faculty',
    qualification: 'Senior Physics Teacher',
    experience: '12 Years',
    specialization: 'Board Physics',
    achievements: [
      'Physics concept specialist',
      'Focus on numerical problem solving',
      'Strong board & competitive results'
    ],
    image: Image5
  },

  {
    id: 6,
    name: 'Radheshyam Prajapat Sir',
    designation: 'English Faculty',
    qualification: 'Senior English Teacher',
    experience: '15 Years',
    specialization: 'English & Communication Skills',
    achievements: [
      '15+ years teaching experience',
      'Improves student communication skills',
      'Board exam preparation expert'
    ],
    image: Image6
  }
];

/* =========================
   DIRECTOR INFO
========================= */

export const directorInfo = {
  name: 'Piyush Soni Sir',
  designation: 'Founder Director & Mathematics Faculty',
  qualification: 'Mathematics Mentor',
  experience: '13 Years',
  image: '/assets/images/faculty/piyush-soni.jpg',
  message: `MANTRA PRAYAS was created in 2020 by vision, optimism and hard work of our team.
I am Piyush Soni, a mathematics mentor guiding and motivating students for IIT-JEE and NEET.

We started with a small beginning as MANTRA for JEE and NEET, with a vision to provide an ideal and unique teaching methodology.
Our belief that no aim is too big and no effort is too small constantly motivates us to improve and innovate.

We continuously upgrade our teaching methodologies to match the ever-changing pattern of top-level engineering and medical entrance exams.
Our courses are designed to meet the needs of aspirants and help them excel in competitive as well as board examinations.

Innovative strategies and disciplined guidance have enabled our students to achieve remarkable results.`,
  vision: 'To be counted among the top education brands with high selections and top ranks',
  mission: 'To inspire, motivate, and guide students towards academic excellence and success'
};
